import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button, Icon, Menu, Dropdown, Modal, message, Input } from 'antd'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import slug from 'constants/slug'
import { autobind } from 'core-decorators'
import createManagerList from 'hoc/manager-list'
import createManagerDelete from 'hoc/manager-delete'
import Breadcrumb from '../breadcrumb'
import UserSearchForm from '../user-search-form'
import createLanguageHoc, { langPropTypes } from '../../../hoc/create-lang'
import UserApi from 'api/UserApi'
import DynamicTable from 'components/elements/dynamic-table'
import AvatarCharacter from 'components/elements/avatar-character'
import ClearFix from 'components/elements/clearfix'
import TimeAgo from 'react-timeago'
import styled from 'styled-components'
import format from 'string-format'
import moment from 'moment/moment'

const AccountWapper = styled.div`
  display: flex;
  align-items: center;
`
const AccountInfo = styled.div`
  display: flex;
  flex-direction: column;
  .email {
    color: #000;
    font-weight: bold;
  }
  .full-name {
    color: #707070;
  }
`
const SpanTimeAgo = styled.div`
  font-size: 13px;
  color: #707070;
`
const LinkSpan = styled.span`
  color: #000;
  &:hover {
    cursor: pointer;
  }
`
const SpanEnable = styled.span`
  color: #fff;
  background-color: ${props => (props.enable ? '#1890ff' : '#9CABB3')};
  border-radius: 5px;
  padding: 1px 5px;
  font-size: 12px;
`
const IconButton = styled(Icon)`
  padding-right: 5px;
  color: ${props => (props.color ? props.color : '#3E90F7')};
`

const Span = styled.span`
  color: ${props => (props.deleted ? '#999999' : '')};
  text-decoration: ${props => (props.deleted ? 'line-through' : '')};
`

@createManagerList({
  apiList: UserApi.getUsers
})
@createManagerDelete({
  apiDelete: UserApi.removeUser
})
@createLanguageHoc
@autobind
export default class UserList extends React.Component {
  static propTypes = {
    pagination: PropTypes.object,
    pathImg: PropTypes.string,
    onChangePage: PropTypes.func,
    onChangePageSize: PropTypes.func,
    onDeleteItem: PropTypes.func,
    fetchData: PropTypes.func,
    lang: langPropTypes
  }

  state = {
    user_id: null,
    password: null
  }

  async componentWillMount() {}

  async onEnableAccount(_id, enable, callback) {
    const { lang: { t } } = this.props
    Modal.confirm({
      title: format(
        t('userManager.list.confirmEnableAccount'),
        enable ? t('userManager.list.enable') : t('userManager.list.disable')
      ),
      onOk() {
        return new Promise(async (resolve, reject) => {
          const data = await UserApi.accountEnable(_id, { enable })
          if (data.success) {
            callback()
          } else {
            message.error(data.message)
          }
          resolve()
        }).catch(() => console.log('Oops errors!'))
      },
      onCancel() {}
    })
  }

  buttonAdd() {
    return (
      <div>
        <Link to={slug.user.create}>
          <Button type="primary">
            <Icon type="plus" />Create
          </Button>
        </Link>
      </div>
    )
  }

  renderSearchForm() {
    return (
      <UserSearchForm
        onChangeSearch={query => {
          this.props.onChangeSearch(query)
        }}
        initialValues={this.props.data}
      />
    )
  }
  actionGroup(row) {
    const { lang: { t } } = this.props
    let accountEnable = true
    if (row.accountStatus && row.accountStatus.enable === false) {
      accountEnable = false
    }
    // const dropdown = (
    //   <Menu>
    //     <Menu.Item key="0">
    //       <Link to={slug.user.editWithKey + '/' + row._id}>
    //         {t('addon.edit')}
    //       </Link>
    //     </Menu.Item>
    //     <Menu.Item key="1">
    //       <a
    //         onClick={() =>
    //           this.props.onDeleteItem(row._id, this.props.fetchData)
    //         }
    //       >
    //         {t('addon.delete')}
    //       </a>
    //     </Menu.Item>
    //     {/* <Menu.Item key="2">
    //         <Link to={slug.user.ruleWithKey + '/' + row._id}>
    //           {t('userManager.list.roleAssign')}
    //         </Link>
    //       </Menu.Item> */}
    //     <Menu.Item key="3">
    //       <a
    //         onClick={() =>
    //           this.onEnableAccount(
    //             row._id,
    //             !accountEnable,
    //             this.props.fetchData
    //           )
    //         }
    //       >
    //         {accountEnable
    //           ? t('userManager.list.disableAccount')
    //           : t('userManager.list.enableAccount')}
    //       </a>
    //     </Menu.Item>
    //   </Menu>
    // )
    let dropdown

    if (row.removeStatus && row.removeStatus.allowed)
      dropdown = this.getMenuIsDeleting(row, t, accountEnable)
    else dropdown = this.getMenuNotDeleting(row, t, accountEnable)

    return (
      <Dropdown overlay={dropdown} trigger={['click']}>
        <LinkSpan className="ant-dropdown-link">
          <Icon type="setting" style={{ fontSize: 20, color: '#3E90F7' }} />
        </LinkSpan>
      </Dropdown>
    )
  }

  getHead() {
    const { lang: { t } } = this.props
    return [
      { content: '#', width: 2 },
      { content: t('userManager.list.email'), width: 30 },
      // { content: t('userManager.list.country'), width: 10 },
      { content: t('userSearchFrom.form.organization.label'), width: 20 },
      { content: t('userManager.list.status'), width: 10 },
      { content: t('userManager.list.createdAt'), width: 15 },
      { content: t('userManager.list.action'), width: 10 },
      { content: t('userManager.list.login'), flex: 1 }
    ]
  }

  getRows() {
    return this.props.dataSource.map((row, index) => {
      const isDeleted = row.removeStatus && row.removeStatus.allowed
      return [
        {
          content: (
            <strong>
              {(this.props.pagination.page - 1) *
                this.props.pagination.itemPerPage +
                index +
                1}
            </strong>
          )
        },
        {
          content: (
            <div>
              {row.phone &&
                row.phone.iso2 && (
                  <AccountWapper>
                    <AvatarCharacter
                      size={32}
                      username={row.email}
                      avatarUrl={row.avatar}
                    />
                    <ClearFix width={4} />
                    <AccountInfo>
                      <Span className={'email'} deleted={isDeleted}>
                        {row.email}
                      </Span>
                      <Span className={'full-name '} deleted={isDeleted}>{`${
                        row.lastName
                      } ${row.firstName}`}</Span>
                    </AccountInfo>
                  </AccountWapper>
                )}
            </div>
          )
        },
        // {
        //   content: (
        //     <div>
        //       {row.phone &&
        //         row.phone.iso2 && (
        //           <div style={{ display: 'flex' }}>
        //             <ReactCountryFlag code={row.phone.iso2} />
        //             {row.phone ? row.phone.name : ''}
        //           </div>
        //         )}
        //     </div>
        //   )
        // },
        {
          content: (
            <Span deleted={isDeleted}>
              {row.organization ? row.organization.name : ''}
            </Span>
          )
        },
        {
          content: (
            <SpanEnable
              enable={
                row.accountStatus && row.accountStatus.enable === false
                  ? false
                  : true
              }
            >
              {row.accountStatus && row.accountStatus.enable === false
                ? 'Disable'
                : 'Enable'}
            </SpanEnable>
          )
        },
        {
          content: (
            <Span deleted={isDeleted}>
              {' '}
              {moment(row.createdAt).format('YYYY-MM-DD HH:mm')}
            </Span>
          )
        },
        {
          content: <Span deleted={isDeleted}>{this.actionGroup(row)}</Span>
        },
        {
          content: (
            <SpanTimeAgo>
              <TimeAgo date={row.lastLoginAt} />
            </SpanTimeAgo>
          )
        }
      ]
    })
  }

  handleSetPassword = ({ key }, user_id) => {
    if (key === '4') {
      this.setState({ password: '', user_id })
    }
  }

  async handleSetPasswordSubmit() {
    const { password, user_id } = this.state
    if (!password || !user_id) return
    const rs = await UserApi.setPassword({ password, _id: user_id })
    if (rs && rs.success) {
      message.success('Update Successfully!')
    } else {
      message.error('Update failed!')
    }

    this.handleSetPasswordClose()
  }

  handleSetPasswordClose = () => {
    this.setState({ password: null, user_id: null })
  }

  handleChangePassword = e => {
    const password = e.target.value
    this.setState({ password })
  }

  getMenuNotDeleting(row, t, accountEnable) {
    return (
      <Menu onClick={e => this.handleSetPassword(e, row._id)}>
        <Menu.Item key="0">
          <Link to={slug.user.editWithKey + '/' + row._id}>
            <IconButton type="edit" />
            {t('addon.edit')}
          </Link>
        </Menu.Item>
        <Menu.Item key="1">
          <a onClick={() => this.onDeleteItem(row._id, this.props.fetchData)}>
            <IconButton type="delete" color={'red'} />
            {t('addon.delete')}
          </a>
        </Menu.Item>
        {/* <Menu.Item key="2">
          <Link to={slug.user.ruleWithKey + '/' + row._id}>
            <IconButton type="usergroup-add" />
            {t('userManager.list.roleAssign')}
          </Link>
        </Menu.Item> */}
        <Menu.Item key="3">
          <a
            onClick={() =>
              this.onEnableAccount(
                row._id,
                !accountEnable,
                this.props.fetchData
              )
            }
          >
            {accountEnable ? (
              <div>
                {' '}
                <IconButton type="user-delete" color="red" />
                {t('userManager.list.disableAccount')}
              </div>
            ) : (
              <div>
                {' '}
                <IconButton type="user-add" />
                {t('userManager.list.enableAccount')}
              </div>
            )}
          </a>
        </Menu.Item>
        <Menu.Item key="4">
          {/* <a
            onClick={() => this.handleSetPassword(row._id)}
          > */}
          <div>
            {' '}
            <IconButton type="lock" />
            {t('userManager.list.setPassword')}
          </div>
          {/* </a> */}
        </Menu.Item>
      </Menu>
    )
  }

  getMenuIsDeleting(row, t, accountEnable) {
    return (
      <Menu>
        <Menu.Item key="1">
          <a onClick={() => this.onRestoreItem(row._id, this.props.fetchData)}>
            <IconButton type="reload" />
            {t('addon.restore')}
          </a>
        </Menu.Item>
        <Menu.Item key="2">
          <a
            onClick={() =>
              this.props.onDeleteItem(row._id, this.props.fetchData)
            }
          >
            <IconButton type="close-square-o" color={'red'} />
            {t('addon.remove')}
          </a>
        </Menu.Item>
      </Menu>
    )
  }

  async onDeleteItem(_id, callback) {
    const { lang: { t } } = this.props
    Modal.confirm({
      title: 'Do you want to delete these items?',
      onOk() {
        return new Promise(async (resolve, reject) => {
          const res = await UserApi.deleteUser(_id)
          if (res.success) {
            message.info(t('addon.onDelete.success'))
            callback()
          } else message.error(t('addon.onDelete.error'))
          resolve()
        }).catch(() => console.log('Oops errors!'))
      },
      onCancel() {}
    })
  }

  async onRestoreItem(_id, callback) {
    const { lang: { t } } = this.props
    Modal.confirm({
      title: 'Do you want to restore these items?',
      onOk() {
        return new Promise(async (resolve, reject) => {
          const res = await UserApi.restoreUser(_id)
          if (res.success) {
            message.info(t('addon.onRestore.success'))
            callback()
          } else message.error(t('addon.onRestore.error'))
          resolve()
        }).catch(() => console.log('Oops errors!'))
      },
      onCancel() {}
    })
  }

  render() {
    return (
      <PageContainer center={this.renderSearchForm()} right={this.buttonAdd()}>
        <Breadcrumb items={['list']} />
        <DynamicTable
          loading={this.props.isLoading}
          rows={this.getRows()}
          head={this.getHead()}
          paginationOptions={{
            isSticky: true
          }}
          onSetPage={this.props.onChangePage}
          pagination={this.props.pagination}
        />
        <Modal
          title={this.props.lang.t('userManager.list.setPassword')}
          visible={!!this.state.user_id}
          onOk={() => this.handleSetPasswordSubmit()}
          onCancel={this.handleSetPasswordClose}
          cancelText="Cancel"
          okText="OK"
        >
          <Input
            type="password"
            placeholder="Input Password"
            onChange={this.handleChangePassword}
          />
        </Modal>
      </PageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/user/user-list/index.js